export default __webpack_public_path__ + "static/media/reveal-article-grey.df3f36fd.svg";